<template>
  <v-container grid-list-md text-center>
    <v-layout wrap>
      <v-flex xs4> </v-flex>
      <v-flex xs4>
        <v-layout justify-center>
          <v-card class="mx-auto">
            <v-card class="text-center">
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout justify-center style="width: 900px">
                    <v-flex xs2> </v-flex>
                    <v-flex xs12 md8>
                      <v-card-text class="headline text-center" primary-title>
                        <div class="justify-center">
                          <v-layout justify-center>
                            <img v-bind:src="logoLink" />
                          </v-layout>
                          <v-layout justify-center>
                            <p class="title">
                              <!-- <font color="#283593">Meu Pix FlowIt</font> -->
                              <font color="#283593">Meu QRCode</font>
                            </p>
                          </v-layout>
                          <v-layout justify-center>
                            <v-btn color="warning" @click="dialog = true"
                              >Pagar com QRCode</v-btn
                            >
                          </v-layout>
                        </div>
                      </v-card-text>
                    </v-flex>
                    <v-flex xs2> </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-divider></v-divider>
            </v-card>
          </v-card>

          <v-dialog v-model="dialog" fullscreen>
            <v-card class="text-center">
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout justify-center>
                    <v-flex xs2> </v-flex>
                    <v-flex xs12 md8>
                      <v-card-text class="headline text-center" primary-title>
                        <div class="justify-center">
                          <v-layout justify-center>
                            <img v-bind:src="logoLink" />
                          </v-layout>
                          <v-layout justify-center>
                            <p class="title">
                              <font color="#283593">Pagamento Instantâneo</font>
                            </p>
                          </v-layout>
                        </div>
                        <div class="center">
                          <v-layout justify-center>
                            <p class="body-1">
                              <font color="#283593" style="text-align: center"
                                >Abra o app, escolha a função
                              </font>
                              <!-- <font color="#42A5F5">Pagar com Pix FlowIt</font> -->
                              <font color="#42A5F5">Pagar com QRCode </font>
                              <font color="#283593">
                                e utilize a câmera do seu celular.</font
                              >
                            </p>
                          </v-layout>
                        </div>
                        <div class="justify-center">
                          <v-layout justify-center>
                            <qrcode-vue
                              :value="account.id.toString()"
                              id="canvas"
                              :size="100"
                            ></qrcode-vue>
                          </v-layout>
                        </div>
                        <br />
                        <v-divider class="mx-4 blue" :inset="inset"></v-divider>
                        <br />
                        <div class="justify-center">
                          <v-layout justify-center>
                            <p class="body-1">
                              <font color="#283593">Pagamento seguro, </font
                              ><font color="#42A5F5">àgil e prático.</font>
                            </p>
                          </v-layout>
                        </div>
                      </v-card-text>
                    </v-flex>
                    <v-flex xs2> </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-text class="text-center noprint">
                <v-spacer></v-spacer>
                <v-btn
                  class="white--text"
                  v-bind:color="color"
                  @click="printDiv"
                  >Imprimir</v-btn
                >
                <v-btn color="warning" @click="dialog = false">Fechar</v-btn>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-flex>
      <v-flex xs4> </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import QrcodeVue from "qrcode.vue";

export default {
  created() {
    this.$store.dispatch("account/getAccount");
  },
  computed: {
    ...mapGetters({
      account: "account/account",
      color: "account/color",
      logoLinkFromStore: "account/logoLink",
      systemLogoUrl: "system/logoUrl",
    }),
    logoLink() {
      // Priorizar logo do sistema (ManageSystem) se disponível
      if (this.systemLogoUrl && this.systemLogoUrl.trim() !== '' && !this.systemLogoUrl.includes('/logo_flowit.png')) {
        return this.systemLogoUrl;
      }
      
      // Fallback para logo da conta se disponível
      if (this.logoLinkFromStore && this.logoLinkFromStore.trim() !== '') {
        return this.logoLinkFromStore;
      }
      
      // Último fallback para logo padrão dos assets
      return require('@/assets/logo_flowit.png');
    },
  },
  watch: {
    logoLink(newValue) {
      if (newValue) {
        this.logoLink = newValue;
      }
    },
  },
  data() {
    return {
      output: null,
      dialog: false,
    };
  },
  methods: {
    printDiv() {
      window.print();
    },
  },
  components: {
    QrcodeVue,
  },
};
</script>
<style>
@media print {
  .noprint {
    display: none;
  }
}
</style>
